// Settings permissions constants for admin configuration
export const SETTINGS_PERMISSIONS = {
  GROUPS: 'groups',
  /** Kallelser / utskick and sent mail history for training groups. */
  GROUP_MAILINGS: 'group_mailings',
  MENTOR_PAGE: 'mentor_page',
  ADMIN_MENTOR_PAGE: 'admin_mentor_page',
  APPROVAL_CENTER: 'approval_center',
  PROMOTIONS: 'promotions',
  CLUB_SETTINGS: 'club_settings',
  USER_ADMIN: 'user_admin',
  CLUB_ATTENDANCE: 'club_attendance',
  /** LOK-stöd administration (mock RF integration UI). */
  LOK_STOD: 'lok_stod',
  SCHEDULE: 'schedule',
  INSTRUCTOR_SCHEDULE: 'instructor_schedule',
  CONTENT: 'content',
  TRAINING_PROGRAM: 'training_program',
  QR_SCANNER: 'qr_scanner',
  TIMER: 'timer',
  BELT_ADMIN: 'belt_admin',
  PAYMENTS: 'payments',
  POS: 'pos',
  /** Kiosk / counter: after login, app opens shop kiosk (set in User Admin → permissions only). */
  POS_KIOSK: 'pos_kiosk',
  /** Kiosk / check-in: after login, app opens QR scanner (set in User Admin → permissions only). */
  ATTENDANCE_KIOSK: 'attendance_kiosk',
  /** Kiosk / display: after login, fullscreen today’s birthdays only (set in User Admin → permissions only). */
  BIRTHDAY_KIOSK: 'birthday_kiosk',
  /** Public signup / intresseanmälan administration. */
  ANMALNINGAR: 'anmalningar',
};

/** UI languages supported by i18n (birthday kiosk display, etc.). */
export const SUPPORTED_UI_LANGUAGES = ['en', 'sv', 'pt', 'es'];

export const DEFAULT_BIRTHDAY_KIOSK_LANGUAGE = 'sv';

export function normalizeUiLanguage(raw) {
  if (raw == null || raw === '') return null;
  const code = String(raw).trim().toLowerCase().slice(0, 2);
  return SUPPORTED_UI_LANGUAGES.includes(code) ? code : null;
}

export function resolveBirthdayKioskLanguage(user) {
  if (!user) return DEFAULT_BIRTHDAY_KIOSK_LANGUAGE;
  return (
    normalizeUiLanguage(user.birthdayKioskLanguage) ||
    normalizeUiLanguage(user.birthday_kiosk_language) ||
    DEFAULT_BIRTHDAY_KIOSK_LANGUAGE
  );
}

// Permission display information - use labelKey and descKey for i18n translation
export const SETTINGS_PERMISSIONS_INFO = {
  [SETTINGS_PERMISSIONS.PAYMENTS]: {
    labelKey: 'economy',
    descKey: 'settings_economy_desc',
    icon: '/icons/economy_icon.png'
  },
  [SETTINGS_PERMISSIONS.POS]: {
    labelKey: 'pos_admin_title',
    descKey: 'settings_pos_desc',
    icon: '/icons/economy_icon.png'
  },
  [SETTINGS_PERMISSIONS.POS_KIOSK]: {
    labelKey: 'settings_permission_pos_kiosk',
    descKey: 'settings_pos_kiosk_desc',
    icon: '/icons/economy_icon.png'
  },
  [SETTINGS_PERMISSIONS.GROUPS]: {
    labelKey: 'groups',
    descKey: 'settings_groups_desc',
    icon: '/icons/groups_icon.png'
  },
  [SETTINGS_PERMISSIONS.GROUP_MAILINGS]: {
    labelKey: 'settings_group_mailings',
    descKey: 'settings_group_mailings_permission_desc',
    icon: '/icons/groups_icon.png'
  },
  [SETTINGS_PERMISSIONS.MENTOR_PAGE]: {
    labelKey: 'mentor_page',
    descKey: 'settings_mentor_page_desc',
    icon: '/icons/mentor_icon.png'
  },
  [SETTINGS_PERMISSIONS.ADMIN_MENTOR_PAGE]: {
    labelKey: 'admin_mentor_management',
    descKey: 'settings_mentor_manager_desc',
    icon: '/icons/mentor_icon.png'
  },
  [SETTINGS_PERMISSIONS.APPROVAL_CENTER]: {
    labelKey: 'approval_center',
    descKey: 'settings_approval_center_desc',
    icon: '/icons/approval_center_icon.png'
  },
  [SETTINGS_PERMISSIONS.PROMOTIONS]: {
    labelKey: 'promotions',
    descKey: 'settings_promotions_desc',
    icon: '/icons/promotion_icon.png'
  },
  [SETTINGS_PERMISSIONS.CLUB_SETTINGS]: {
    labelKey: 'club_settings',
    descKey: 'settings_club_settings_desc',
    icon: '/icons/settings_icon.png'
  },
  [SETTINGS_PERMISSIONS.USER_ADMIN]: {
    labelKey: 'user_admin',
    descKey: 'settings_user_admin_desc',
    icon: '/icons/useradmin_icon.png'
  },
  [SETTINGS_PERMISSIONS.CLUB_ATTENDANCE]: {
    labelKey: 'club_attendance',
    descKey: 'settings_club_attendance_desc',
    icon: '/icons/club_attendance_icon.png'
  },
  [SETTINGS_PERMISSIONS.LOK_STOD]: {
    labelKey: 'lok_page_title',
    descKey: 'settings_lok_stod_desc',
    icon: '/icons/club_attendance_icon.png'
  },
  [SETTINGS_PERMISSIONS.SCHEDULE]: {
    labelKey: 'schedule_title',
    descKey: 'settings_schedule_desc',
    icon: '/icons/schedule_icon.png'
  },
  [SETTINGS_PERMISSIONS.INSTRUCTOR_SCHEDULE]: {
    labelKey: 'instructor_schedule_title',
    descKey: 'settings_instructor_schedule_desc',
    icon: '/icons/instructor_schedule_icon.png'
  },
  [SETTINGS_PERMISSIONS.CONTENT]: {
    labelKey: 'content_page',
    descKey: 'settings_content_desc',
    icon: '/icons/content_icon.png'
  },
  [SETTINGS_PERMISSIONS.TRAINING_PROGRAM]: {
    labelKey: 'training_program',
    descKey: 'settings_training_program_desc',
    icon: '/icons/content_icon.png'
  },
  [SETTINGS_PERMISSIONS.QR_SCANNER]: {
    labelKey: 'qr_scanner',
    descKey: 'settings_qr_scanner_desc',
    icon: '/icons/qr_code_icon.png'
  },
  [SETTINGS_PERMISSIONS.TIMER]: {
    labelKey: 'timer',
    descKey: 'settings_timer_desc',
    icon: '/icons/timer_icon.png'
  },
  [SETTINGS_PERMISSIONS.BELT_ADMIN]: {
    labelKey: 'belt_administration',
    descKey: 'settings_belt_admin_desc',
    icon: '/icons/belts_icon.png'
  },
  [SETTINGS_PERMISSIONS.ATTENDANCE_KIOSK]: {
    labelKey: 'settings_permission_attendance_kiosk',
    descKey: 'settings_attendance_kiosk_desc',
    icon: '/icons/club_attendance_icon.png'
  },
  [SETTINGS_PERMISSIONS.BIRTHDAY_KIOSK]: {
    labelKey: 'settings_permission_birthday_kiosk',
    descKey: 'settings_birthday_kiosk_desc',
    icon: '/icons/club_attendance_icon.png'
  },
  [SETTINGS_PERMISSIONS.ANMALNINGAR]: {
    labelKey: 'anmalningar_page_title',
    descKey: 'settings_anmalningar_desc',
    icon: '/icons/groups_icon.png'
  },
};

/** Grouped like Settings → categories so every permission is easy to find in User Admin. */
export const SETTINGS_PERMISSION_DIALOG_CATEGORIES = [
  {
    labelKey: 'settings_category_members',
    permissions: [
      SETTINGS_PERMISSIONS.USER_ADMIN,
      SETTINGS_PERMISSIONS.GROUPS,
      SETTINGS_PERMISSIONS.GROUP_MAILINGS,
      SETTINGS_PERMISSIONS.ANMALNINGAR,
    ],
  },
  {
    labelKey: 'settings_category_club_setup',
    permissions: [SETTINGS_PERMISSIONS.CLUB_SETTINGS, SETTINGS_PERMISSIONS.APPROVAL_CENTER],
  },
  {
    labelKey: 'settings_category_billing',
    permissions: [SETTINGS_PERMISSIONS.PAYMENTS, SETTINGS_PERMISSIONS.POS, SETTINGS_PERMISSIONS.POS_KIOSK],
  },
  {
    labelKey: 'settings_category_grading',
    permissions: [SETTINGS_PERMISSIONS.PROMOTIONS, SETTINGS_PERMISSIONS.BELT_ADMIN],
  },
  {
    labelKey: 'settings_category_instruction',
    permissions: [
      SETTINGS_PERMISSIONS.ADMIN_MENTOR_PAGE,
      SETTINGS_PERMISSIONS.SCHEDULE,
      SETTINGS_PERMISSIONS.INSTRUCTOR_SCHEDULE,
      SETTINGS_PERMISSIONS.MENTOR_PAGE,
      SETTINGS_PERMISSIONS.TIMER,
    ],
  },
  {
    labelKey: 'settings_category_attendance_kiosks',
    permissions: [
      SETTINGS_PERMISSIONS.QR_SCANNER,
      SETTINGS_PERMISSIONS.CLUB_ATTENDANCE,
      SETTINGS_PERMISSIONS.LOK_STOD,
      SETTINGS_PERMISSIONS.ATTENDANCE_KIOSK,
      SETTINGS_PERMISSIONS.BIRTHDAY_KIOSK,
    ],
  },
  {
    labelKey: 'settings_category_content_tools',
    permissions: [SETTINGS_PERMISSIONS.CONTENT, SETTINGS_PERMISSIONS.TRAINING_PROGRAM],
  },
];

const LEGACY_PERMISSION_ALIASES = {
  mentors: SETTINGS_PERMISSIONS.ADMIN_MENTOR_PAGE,
  members: SETTINGS_PERMISSIONS.USER_ADMIN,
};

const KIOSK_ONLY_KEYS = new Set([
  SETTINGS_PERMISSIONS.ATTENDANCE_KIOSK,
  SETTINGS_PERMISSIONS.POS_KIOSK,
  SETTINGS_PERMISSIONS.BIRTHDAY_KIOSK,
]);

const DASHBOARD_WIDGET_PERMISSIONS = [
  SETTINGS_PERMISSIONS.SCHEDULE,
  SETTINGS_PERMISSIONS.CLUB_ATTENDANCE,
  SETTINGS_PERMISSIONS.QR_SCANNER,
  SETTINGS_PERMISSIONS.LOK_STOD,
  SETTINGS_PERMISSIONS.PAYMENTS,
  SETTINGS_PERMISSIONS.POS,
  SETTINGS_PERMISSIONS.APPROVAL_CENTER,
  SETTINGS_PERMISSIONS.INSTRUCTOR_SCHEDULE,
  SETTINGS_PERMISSIONS.PROMOTIONS,
];

export function normalizeSettingsPermissionKey(raw) {
  if (raw == null || raw === '') return null;
  const key = String(raw).trim();
  if (LEGACY_PERMISSION_ALIASES[key]) return LEGACY_PERMISSION_ALIASES[key];
  return Object.values(SETTINGS_PERMISSIONS).includes(key) ? key : null;
}

/** Flat list of every assignable permission (for Select all / counts). */
export function getAllSettingsPermissionKeys() {
  return Object.values(SETTINGS_PERMISSIONS);
}

/** Permissions shown in the dialog, in category order (deduped). */
export function getSettingsPermissionsForDialog() {
  const seen = new Set();
  const ordered = [];
  for (const cat of SETTINGS_PERMISSION_DIALOG_CATEGORIES) {
    for (const key of cat.permissions) {
      if (!seen.has(key) && SETTINGS_PERMISSIONS_INFO[key]) {
        seen.add(key);
        ordered.push(key);
      }
    }
  }
  for (const key of getAllSettingsPermissionKeys()) {
    if (!seen.has(key) && SETTINGS_PERMISSIONS_INFO[key]) {
      ordered.push(key);
    }
  }
  return ordered;
}

export function resolveEffectivePermissions(user) {
  if (!user) return [];
  const isAdmin = user.isAdmin === true;
  const isCoach = user.isCoach === true;
  if (!isAdmin && !isCoach) return [];

  const raw = user.settingsPermissions ?? user.settings_permissions;
  if (isAdmin && (!Array.isArray(raw) || raw.length === 0)) {
    return Object.values(SETTINGS_PERMISSIONS);
  }
  if (!Array.isArray(raw)) return [];

  const out = [];
  for (const item of raw) {
    const key = normalizeSettingsPermissionKey(item);
    if (key && !out.includes(key)) out.push(key);
  }
  return out;
}

export function userHasDashboardWidgets(user) {
  const perms = resolveEffectivePermissions(user);
  return DASHBOARD_WIDGET_PERMISSIONS.some((p) => perms.includes(p));
}

export function userShowsStaffDashboard(user) {
  if (!user) return false;
  const isAdmin = user.isAdmin === true;
  const isCoach = user.isCoach === true;
  if (!isAdmin && !isCoach) return false;

  const raw = user.settingsPermissions ?? user.settings_permissions;
  if (isAdmin && (!Array.isArray(raw) || raw.length === 0)) {
    return true;
  }

  const perms = resolveEffectivePermissions(user);
  if (perms.length > 0 && perms.every((p) => KIOSK_ONLY_KEYS.has(p))) {
    return false;
  }
  return userHasDashboardWidgets(user);
}

export function findLoggedInAccount(localUserInfo, loggedInEmail) {
  if (!loggedInEmail || !Array.isArray(localUserInfo)) return null;
  const normalized = loggedInEmail.toLowerCase().trim();
  const matches = localUserInfo.filter(
    (u) => u.email && u.email.toLowerCase().trim() === normalized
  );
  if (matches.length === 0) return null;
  // Login email belongs to the authenticated parent/admin — not a child who may share the same email.
  return matches.find((u) => u.isParent === true) || matches[0];
}

export function isViewingLoggedInAccount(activeUser, loggedInEmail, localUserInfo) {
  if (!activeUser || !loggedInEmail) return false;
  const loggedIn = findLoggedInAccount(localUserInfo, loggedInEmail);
  if (!loggedIn) return false;
  return activeUser.studentID === loggedIn.studentID;
}

export function shouldShowStaffDashboard(activeUser, loggedInEmail, localUserInfo) {
  if (!isViewingLoggedInAccount(activeUser, loggedInEmail, localUserInfo)) return false;
  const staffUser = findLoggedInAccount(localUserInfo, loggedInEmail) || activeUser;
  return userShowsStaffDashboard(staffUser);
}

// Helper function to check if user has specific permission
export const hasSettingsPermission = (userInfo, permission) => {
  if (!userInfo || !Array.isArray(userInfo) || userInfo.length === 0) return false;

  const user = userInfo[0];
  if (!user) return false;
  const isAdmin = user.isAdmin === true;
  const isCoach = user.isCoach === true;
  if (!isAdmin && !isCoach) return false;

  return resolveEffectivePermissions(user).includes(permission);
};

/** Anmälningar admin — own permission or training groups access. */
export function hasAnmalningarAccess(userInfo) {
  return (
    hasSettingsPermission(userInfo, SETTINGS_PERMISSIONS.ANMALNINGAR) ||
    hasSettingsPermission(userInfo, SETTINGS_PERMISSIONS.GROUPS)
  );
}

/** Group mailings — own permission or training groups access (legacy). */
export function hasGroupMailingsAccess(userInfo) {
  return (
    hasSettingsPermission(userInfo, SETTINGS_PERMISSIONS.GROUP_MAILINGS) ||
    hasSettingsPermission(userInfo, SETTINGS_PERMISSIONS.GROUPS)
  );
}

/** Total pending items for the admin Settings nav badge (respects each permission). */
export function getSettingsNavBadgeCount(userInfo, counts = {}) {
  const {
    unreviewedMembersCount = 0,
    pendingParentRequestsCount = 0,
    pendingInstructorAttendancesCount = 0,
    adultPromotions = 0,
    childPromotions = 0,
    unpublishedBeltPromotions = 0,
    pendingAnmalningSubmissionsCount = 0,
  } = counts;

  let total = 0;

  if (hasSettingsPermission(userInfo, SETTINGS_PERMISSIONS.APPROVAL_CENTER)) {
    total +=
      unreviewedMembersCount +
      pendingParentRequestsCount +
      pendingInstructorAttendancesCount +
      adultPromotions +
      childPromotions +
      pendingAnmalningSubmissionsCount;
  }

  if (hasSettingsPermission(userInfo, SETTINGS_PERMISSIONS.PROMOTIONS)) {
    total += unpublishedBeltPromotions;
  }

  if (hasAnmalningarAccess(userInfo) && !hasSettingsPermission(userInfo, SETTINGS_PERMISSIONS.APPROVAL_CENTER)) {
    total += pendingAnmalningSubmissionsCount;
  }

  return total;
}

// Helper function to get all permissions for a user
export const getUserSettingsPermissions = (userInfo) => {
  if (!userInfo || !Array.isArray(userInfo) || userInfo.length === 0) return [];

  const user = userInfo[0];
  if (!user) return [];
  return resolveEffectivePermissions(user);
};

/**
 * Explicit permission list on the user row (not legacy empty = all).
 */
function getExplicitSettingsPermissions(user) {
  if (!user) return [];
  const raw = user.settingsPermissions ?? user.settings_permissions;
  if (!Array.isArray(raw)) return [];
  return raw.map(normalizeSettingsPermissionKey).filter(Boolean);
}

function userIsStaffForKiosk(user) {
  return user?.isAdmin === true || user?.isCoach === true;
}

/**
 * User has the "Attendance (kiosk)" permission explicitly set (not legacy empty = all).
 * Used only for post-login redirect to QR scanner.
 */
export const userHasAttendanceKioskLogin = (userInfo) => {
  if (!userInfo || !Array.isArray(userInfo) || userInfo.length === 0) return false;
  const user = userInfo[0];
  if (!userIsStaffForKiosk(user)) return false;
  return getExplicitSettingsPermissions(user).includes(SETTINGS_PERMISSIONS.ATTENDANCE_KIOSK);
};

/**
 * User has the "Shop kiosk" permission explicitly set (not legacy empty = all).
 * Used for kiosk access checks (Settings / POS admin entry).
 */
export const userHasPosKioskLogin = (userInfo) => {
  if (!userInfo || !Array.isArray(userInfo) || userInfo.length === 0) return false;
  const user = userInfo[0];
  if (!userIsStaffForKiosk(user)) return false;
  return getExplicitSettingsPermissions(user).includes(SETTINGS_PERMISSIONS.POS_KIOSK);
};

/**
 * User has the "Birthday display (kiosk)" permission explicitly set (not legacy empty = all).
 * Does not require admin/coach — dedicated kiosk accounts are often plain member logins.
 */
export const userHasBirthdayKioskLogin = (userInfo) => {
  if (!userInfo || !Array.isArray(userInfo) || userInfo.length === 0) return false;
  const user = userInfo[0];
  return getExplicitSettingsPermissions(user).includes(SETTINGS_PERMISSIONS.BIRTHDAY_KIOSK);
};

export const userCanAccessPosKiosk = (userInfo) =>
  userHasPosKioskLogin(userInfo) ||
  hasSettingsPermission(userInfo, SETTINGS_PERMISSIONS.POS) ||
  hasSettingsPermission(userInfo, SETTINGS_PERMISSIONS.PAYMENTS);

/** LOK-stöd: dedicated permission, or club attendance admins (same Settings section). */
export function hasLokStodAccess(userInfo) {
  return (
    hasSettingsPermission(userInfo, SETTINGS_PERMISSIONS.LOK_STOD) ||
    hasSettingsPermission(userInfo, SETTINGS_PERMISSIONS.CLUB_ATTENDANCE)
  );
}
